import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import DropdownInsideLabel from '../../../FormElements/DropdownInsideLabel';
import config from '../../../../helpers/config';
import { sites } from '../../../../helpers/globalVariables';

class EditMeasurements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      width: this.props.width,
      height: this.props.height,
      dimensions: {
        MinHeight: this.props.minHeight,
        MaxHeight: this.props.maxHeight,
        MinWidth: this.props.minWidth,
        MaxWidth: this.props.maxWidth,
      },
    };
  }

  getMinMaxDimensions = () => {
    const url = `/Catalog/ProductConfiguration/ProductDimension?productid=${this.props.productId}`;
    let data = {};
    axios.get(url).then((response) => {
      ({ data } = response);
      this.setState({ dimensions: data });
    });
  }

  getPossibleWidths = () => {
    const options = [];
    const minWidthFloor = Math.floor(this.state.dimensions.MinWidth);
    for (let i = minWidthFloor; i <= this.state.dimensions.MaxWidth; i += 1) {
      options.push({ name: `${i}&quot;`, value: `${i}` });
    }
    return options;
  }

  getPossibleHeights = () => {
    const options = [];
    const minHeightFloor = Math.floor(this.state.dimensions.MinHeight);
    for (let i = minHeightFloor; i <= this.state.dimensions.MaxHeight; i += 1) {
      options.push({ name: `${i}&quot;`, value: `${i}` });
    }
    return options;
  }

  getPossibleEighths = () => {
    const options = [
      { name: '0/0', value: '0', display: '0/0' },
      { name: '1/8', value: '0.125', display: '1/8' },
      { name: '1/4', value: '0.25', display: '1/4' },
      { name: '3/8', value: '0.375', display: '3/8' },
      { name: '1/2', value: '0.5', display: '1/2' },
      { name: '5/8', value: '0.625', display: '5/8' },
      { name: '3/4', value: '0.75', display: '3/4' },
      { name: '7/8', value: '0.875', display: '7/8' },
    ];
    return options;
  }

  getWholeInches = inches => Math.floor(inches);

  getDecimalInches = inches => inches % 1;

  getEighths = (inches) => {
    const decimal = inches % 1;
    if (decimal) {
      return this.fractions[decimal];
    }
    return 0;
  }

  widthWholeChanged = (e) => {
    const decimal = this.getDecimalInches(this.state.width);
    const width = Number(e.target.value) + Number(decimal);
    this.setState({ width });
  }

  widthEighthsChanged = (e) => {
    const whole = this.getWholeInches(this.state.width);
    const width = Number(e.target.value) + Number(whole);
    this.setState({ width });
  }

  heightWholeChanged = (e) => {
    const decimal = this.getDecimalInches(this.state.height);
    const height = Number(e.target.value) + Number(decimal);
    this.setState({ height });
  }

  heightEighthsChanged = (e) => {
    const whole = this.getWholeInches(this.state.height);
    const height = Number(e.target.value) + Number(whole);
    this.setState({ height });
  }

  formatInches = (inches) => {
    const wholeInches = Math.floor(inches);
    const decimal = inches % 1;

    if (decimal > 0) {
      return `${wholeInches} ${this.fractions[decimal]}"`;
    }

    return `${wholeInches}"`;
  };

  updateMeasurements = () => {
    this.toggleEdit();
    this.props.updateMeasurement(
      this.props.designId,
      this.props.itemId,
      this.state.width,
      this.state.height,
    );
  }

  toggleEdit = () => {
    if (!this.state.showEdit) {
      this.getMinMaxDimensions();
      this.setState({
        width: this.props.width,
        height: this.props.height,
      });
    }
    this.setState({ showEdit: !this.state.showEdit });
  }

  fractions = {
    0.125: '1/8',
    0.25: '1/4',
    0.375: '3/8',
    0.5: '1/2',
    0.625: '5/8',
    0.75: '3/4',
    0.875: '7/8',
  };

  render() {
    if (this.state.showEdit) {
      return (
        <div className="editMeasurements">
          <div className={config.siteId === sites.theHomeDepot ? 'homedepotcom' : ''}>
            <div className="dimension">
              <div className="dimensionRow">
                <span className="label">W:</span>
                <DropdownInsideLabel
                  name="width-whole"
                  value={`${this.getWholeInches(this.state.width)}`}
                  onChange={this.widthWholeChanged}
                  options={this.getPossibleWidths()}
                  label=""
                />
                <DropdownInsideLabel
                  name="width-eighths"
                  value={`${this.getDecimalInches(this.state.width)}`}
                  onChange={this.widthEighthsChanged}
                  options={this.getPossibleEighths()}
                  label=""
                />
              </div>
            </div>
            <div className="dimension">
              <div className="dimensionRow">
                <span className="label">H:</span>
                <DropdownInsideLabel
                  name="height-whole"
                  value={`${this.getWholeInches(this.state.height)}`}
                  onChange={this.heightWholeChanged}
                  options={this.getPossibleHeights()}
                  label=""
                />
                <DropdownInsideLabel
                  name="height-eighths"
                  value={`${this.getDecimalInches(this.state.height)}`}
                  onChange={this.heightEighthsChanged}
                  options={this.getPossibleEighths()}
                  label=""
                />
              </div>
            </div>
          </div>
          <button
            className="btn btn-primary float-right"
            onClick={this.updateMeasurements}
            title="Update Measurements"
          >
            &nbsp;
          </button>
        </div>
      );
    }
    const className = this.props.allowEdit ? 'displayMeasurements' : '';

    return (
      <div onClick={this.props.allowEdit ? this.toggleEdit : null} role="button" tabIndex={0} className={className}>
        <table>
          <tbody>
            <tr key={`${this.props.itemId}-width`}>
              <td className="optionValue">{this.formatInches(this.props.width)}</td>
            </tr>
            <tr key={`${this.props.itemId}-height`}>
              <td className="optionValue">{this.formatInches(this.props.height)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

EditMeasurements.propTypes = {
  designId: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  updateMeasurement: PropTypes.func.isRequired,
  productId: PropTypes.number.isRequired,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  minHeight: PropTypes.number,
  maxHeight: PropTypes.number,
  allowEdit: PropTypes.bool,
};

EditMeasurements.defaultProps = {
  minWidth: 7,
  maxWidth: 156,
  minHeight: 10,
  maxHeight: 160,
  allowEdit: false,
};

export default EditMeasurements;
